<template>
  <TrainingProcessLog
    :extra-params="extraParams"
    :visible="visible"
    :extra-id="$attrs['extra-id']"
    api-url="/workspace/manager/training/topicVerify/topicProcessLog"
    log-type-name="选题" />
</template>

<script>
import TrainingProcessLog from '../../common/TrainingProcessLog'
export default {
  name: 'TrainingTopicVerifyProcessLog',
  components: {
    TrainingProcessLog
  },
  props: {
    extraParams: Object,
    visible: Boolean
  }
}
</script>
